export enum Category {
  PRODUCAO = 'Produção',
  EPI = 'Epis',
  LIMPEZA = 'Limpeza',
  MANUTENCAO = 'Manutenção',
  TINTASCOLORIDAS = 'Tintas',
}
